import React from 'react'
import { twMerge } from 'tailwind-merge'
import { ChevronType, Color, Direction } from '../../utils/constants'
import Chevron from '../Chevron'

export enum ButtonSize {
  SMALL,
  MEDIUM,
  LARGE,
}

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode
  buttonColor?: Color
  chevron?: Direction
  isInverted?: boolean
  outerClasses?: string
  innerClasses?: string
}

const Button = (props: ButtonProps) => {
    const {
        children,
        buttonColor = Color.BLACK,
        chevron,
        isInverted = false,
        disabled,
        outerClasses,
        innerClasses,
        ...rest
    } = props
    const getButtonColor = () => {
        switch (buttonColor) {
        case Color.BLACK:
        default:
            return isInverted ? 'text-white fill-white bg-black' : 'text-black fill-black'
        case Color.PURPLE:
            return isInverted
                ? 'text-white fill-white bg-purple'
                : 'text-purple fill-purple group-hover:bg-purple group-hover:text-white group-hover:fill-white'
        case Color.WHITE:
            return isInverted
                ? 'text-black fill-black bg-white'
                : 'text-white fill-white group-hover:bg-white group-hover:text-black group-hover:fill-black'
        }
    }

    const getButtonBorder = () => {
        switch (buttonColor) {
        case Color.BLACK:
        default:
            return 'border-black'
        case Color.PURPLE:
            return 'border-purple'
        case Color.WHITE:
            return 'border-white'
        }
    }

    return (
        <button
            className={twMerge(
                'border rounded-full group',
                getButtonBorder(),
                disabled && 'opacity-60',
                outerClasses,
            )}
            disabled={disabled}
            {...rest}
        >
            <div
                className={twMerge(
                    'transition-all duration-500 ease-out rounded-full px-8 py-5',
                    isInverted && 'group-hover:px-7 group-hover:py-4 group-hover:m-1',
                    getButtonColor(),
                    innerClasses,
                )}
            >
                {chevron ? (
                    <div className='flex items-center justify-center'>
                        {children}
                        <Chevron direction={chevron} type={ChevronType.FULL} />
                    </div>
                ) : (
                    children
                )}
            </div>
        </button>
    )
}

export default Button
